import React from 'react';
import { bool, func, string } from 'prop-types';


const Highlight = props => {
  let ariaLabelledBy;
  let titleId;
  let descId;

  const {
    hidden, title, desc, role,
    width, height, viewBox,
    fill, className, handleClick
  } = props;

  if (title) {
    titleId = (Math.random() * 100000).toFixed(0);
    ariaLabelledBy = `${titleId}`;
  }

  if (desc) {
    descId = (Math.random() * 100000).toFixed(0);
    ariaLabelledBy += ` ${descId}`;
  }

  return (
    <svg className={ className } onClick={ handleClick }
      width={ width }
      height={ height }
      viewBox={ viewBox }
      fill={ fill }
      role={ role }
      aria-labelledby={ ariaLabelledBy }
      aria-hidden={ hidden }>

      {title
        ? <title id={ titleId }>{ title }</title>
        : null
      }

      {desc
        ? <desc id={ descId }>{ desc }</desc>
        : null
      }

      <g>
        <rect x="4" y="19" width="16" height="2" />
        <path d="M18.69,5.41a1,1,0,0,0,0-1.41L17,2.29a1,1,0,0,0-1.41,0L14.18,3.7l3,3.13Z" fillRule="evenodd" />
        <polygon points="16.17 7.82 13.14 4.68 4 13.97 4 17 6.97 17 16.17 7.82" fillRule="evenodd" />
      </g>
    </svg>
  );
};

Highlight.defaultProps = {
  className: '',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: '#000000',
  role: 'img',
  title: '',
  desc: '',
  hidden: false
};

Highlight.propTypes = {
  className: string,
  width: string,
  height: string,
  viewBox: string,
  fill: string,
  role: string,
  title: string,
  desc: string,
  hidden: bool
};


export default Highlight;
